export default __webpack_public_path__ + "static/splash-4ba87e8e7d62670dbd19c1d8690b032b.svg";